import Gcik from "../images/gcik.svg";
import blueGcik from "../images/blueGcik.svg";
import pinkGcik from "../images/pinkGcik.svg";
import greenGcik from "../images/greenGcik.png";
import fuchsiaGcik from "../images/fuchsiaGcik.svg";
import classNames from "../utils";

export default function DescriptionBlock({ title , subTitle, description ,icon, color}) {

  const makeColor = () => {
    if(color === 'orange') {
      return 'text-[#FF9D00]'
    }
    if(color === 'green') {
      return 'text-[#0FBA68]'
    }
    if(color === 'pink') {
      return 'text-[#F94171]'
    }
    if(color === 'blue') {
      return 'text-[#3D90F4]'
    }
    if(color === 'fuchsia') {
      return 'text-[#E75CFE]'
    }
  }

  const makeBorder = () => {
    if(color === 'orange') {
      return 'border-[#FF9D00]'
    }
    if(color === 'green') {
      return 'border-[#0FBA68]'
    }
    if(color === 'pink') {
      return 'border-[#F94171]'
    }
    if(color === 'blue') {
      return 'border-[#3D90F4]'
    }
    if(color === 'fuchsia') {
      return 'border-[#E75CFE]'
    }
  }

  const makeImage = () => {
    if(color === 'orange') {
      return Gcik
    }
    if(color === 'green') {
      return greenGcik
    }
    if(color === 'pink') {
      return pinkGcik
    }
    if(color === 'blue') {
      return blueGcik
    }
    if(color === 'fuchsia') {
      return fuchsiaGcik
    }
  }


  return (
    <div className={classNames('max-w-[550px] border-[4px] md:border-[6px] rounded-2xl shadow-2xl p-3 md:p-10 relative z-40 bg-white',makeBorder(color))}>
      <div className="flex">
        <div>
        <h2 className="text-xl text-[#3E3838] mb-4">{subTitle}</h2>
          <p className={classNames('uppercase text-3xl md:text-4xl font-black', makeColor(color))}>
            {title}
          </p>
          <img  alt="svg" src={makeImage(color)}  />
        </div>
        <img className="max-w-[150px] md:max-w-[300px]"  alt="svg" src={icon}  />
      </div>
      <p className="mt-6 text-[#313131]">{description}</p>
    </div>
  );
}
